module.exports = __webpack_public_path__ + "img/list-bg@3x.7ae04873.png";